module.exports = __webpack_public_path__ + "media/images/talent/feature04-ced1be2f71d0be5e19ee2d4b104930db.png";